import { motion } from "framer-motion";
import {MAX_ROWS, MOBILE_MAX_ROWS, systemGreyLight, systemWhite} from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

export const ITEM_WIDTH = 160;
export const ITEM_HEIGHT = 83;

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const BrandsSectionContent = createStyledElement(motion.section, () => ({
  padding: isMobileViewport() ? "30px 16px" : "50px 40px",
}));

export const BrandsContainer = createStyledElement("div", () => ({
  display: "grid",
  gridTemplateColumns: `repeat(auto-fill, minmax(${ITEM_WIDTH}px, 1fr))`,
  maxHeight: `calc(${ITEM_HEIGHT}px * ${isMobileViewport() ? MOBILE_MAX_ROWS : MAX_ROWS})`,
  overflow: "hidden",
  gap: 0,
  marginTop: 50,
}));

export const BrandItem = createStyledElement("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: systemWhite,
  border: `1px solid ${systemGreyLight}`,
  minHeight: ITEM_HEIGHT,
  textAlign: "center",
  margin: 0,
});

export const BrandLogo = createStyledElement("img", {
  maxWidth: ITEM_WIDTH,
  maxHeight: 81,
});
